import _ from 'lodash'

/**
 * 通过 meta.role 判断是否与当前用户权限匹配，没有配置 roles 默认可访问
 * @param {array} roles
 * @param {[string]} route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.indexOf(role) >= 0)
  }
  return true
}

/**
 * 递归路由，将后代路由配置的 roles 赋值给祖先路由
 * @param {array} routerMap 路由配置表
 */
function cookRouterMap(routerMap) {
  const recurRouter = (routeList) => {
    return routeList.map(route => {
      if (route.meta && route.meta.roles) {
        // 递归条件
        if (route.children && route.children.length) {
          route.meta.roles = [...route.meta.roles, ..._.flattenDeep(recurRouter(route.children))]
        }
        return route.meta.roles // 基线条件
      }
      return ''
    })
  }

  recurRouter(routerMap)
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param {array} asyncRouterMap
 * @param {[string]} roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  const accessibleRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessibleRouters
}

const permission = {
  state: {
    routers: [],
    accessibleRouters: [], // 当前用户可访问路由
    currentRouter: null // 当前路由
  },

  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.accessibleRouters = routers
      state.routers = state.routers.concat(routers)
    },
    SET_ROUTERSMAP: (state, routers) => {
      state.routers = routers
    },
    UPDATE_CURRENT_ROUTER: (state, router) => {
      console.log('当前路由', router)
      state.currentRouter = router
    }
  },

  actions: {
    GenerateRoutes({ commit }, { roles, asyncRouterMap, routerMap }) {
      const temp = asyncRouterMap
      commit('SET_ROUTERSMAP', routerMap)
      cookRouterMap(temp) // 更新路由配置种的 roles
      return new Promise(resolve => {
        const accessibleRouters = filterAsyncRouter(temp, roles)
        commit('SET_ROUTERS', accessibleRouters)
        resolve()
      })
    }
  }
}

export default permission
